// extracted by mini-css-extract-plugin
export default {"root":"gift_card_store_payment_page_root__cQbCC"};